window.PlanBuilderAdress = (function(Loc){
	
	var self = {};
	
	self.init = function(){
		
		// prepare filter form
		var formId = "planbuilderadress";
		var options = {
			beforeSubmit : function(){
				$("#"+formId+" input[type=submit]").val(Loc.g('Chargement...')).attr('disabled', 'disabled');
			},
			success:function(data){
				
				$("#"+formId+" input[type=submit]").val(Loc.g('Ajouter cette adresse')).removeAttr('disabled');
				
				var formIsOk = MyForm.processJson(data, "planbuilderadress");
				if (formIsOk){
                    let target = "/?_f=planbuilder";

                    let urlParams = new URLSearchParams(window.location.search);
                    if (urlParams.get('action')) target += "&action=" + urlParams.get('action');
                    window.location = target;

				}
			
		}, dataType:"json"};
		var data = {action: 'recordBuilderadress'};
		MyForm.prepare(formId, "planbuilder&"+$.param(data), options, true);
		
	};
	
	return self;
	
})(Loc);

window.PlanBuilderQuota = (function(Loc){
	
	var self = {};
	self.builder = null;
	
	self.init = function(){
		
		// prepare filter form
		var formId = "planbuilder";
		var options = {
			beforeSubmit : function(){
				$("#"+formId+" input[type=submit]").val(Loc.g('Chargement...')).attr('disabled', 'disabled');
			},
			success:function(data){
				
				$("#"+formId+" input[type=submit]").val(Loc.g('Confirmer')).removeAttr('disabled');
				
				var formIsOk = MyForm.processJson(data, "planbuilder");
				if (formIsOk){

					var opt = {
						title:	Loc.g('Votre devis est créé'),
						type:	'confirm',
						buttons: [{
							text: Loc.g("Voir le devis"),
							click: function () {
								window.location.href = data.result.redirectUrl;
							}
						}],
					};
					MyWindow.alert(Loc.g('Vous allez être redirigé dans quelques secondes'), opt);

					setTimeout(function() {
						window.location.href = data.result.redirectUrl;
					}, 1000);

				}
			
		}, dataType:"json"};
		var data = {action: 'recordBuilderQuota'};
		MyForm.prepare(formId, "planbuilder&"+$.param(data), options, true);
	
		self.builder = $("#"+formId);
	
		$('input[type="number"]').on('blur click change keyup mouseup', function(){
			self.calculatePrice();
		});
		
	};
	
	self.calculatePrice = function(){
		
		var amount = new Big(0);
		
		$('input[type="number"]').each(function(){
			var qt			= new Big(parseInt($(this).val(), 10));
			var price		= new Big(parseFloat($(this).next().val(), 10));
			var rowTotal	= qt.times(price);
			amount			= amount.plus(rowTotal);
		});
		
		var numFormat = NumberFormat.load();
		
		amount = NumberFormat.formatToDisplay(amount.toString(), numFormat);
		
		self.builder.find('.final-price .price-yearly').html(amount);
		
	};
	
	return self;
	
})(Loc);

window.PlanBuilder = (function(Loc){
	
	var self = {};
	
	self.builder = null;
	self.plan = null;
	self.addonPrice = null;
	self.rqtype = null;
	self.nbMonthsLeft = null;

	self.init = function(){
		
		// prepare filter form
		var formId = "planbuilder";

		var options = {
			beforeSubmit : function(){
				$("#"+formId+" input[type=submit]").val(Loc.g('Chargement...')).attr('disabled', 'disabled');
				MyFacture.startWait();
			},
			success : function(data){
				MyFacture.stopWait();

				$("#"+formId+" input[type=submit]").val(Loc.g('Confirmer')).removeAttr('disabled');
				
				var formIsOk = MyForm.processJson(data, "planbuilder");

				if (formIsOk){

					var options = {
						dialogClass : "white",
						title		: Loc.g('Votre devis est créé'),
						buttons		: []
					};


					if(data.result.hasEsign){
						var message = Loc.g("Votre devis doit maintenant être validé. Un mail a été envoyé à l'adresse")
							+ ' <strong>' + data.result.contacts.main.email + '</strong> '+Loc.g("pour procéder à cette validation")+'.';

						options.buttons.push({
							text	: Loc.g("Ok"),
							'class'	: "btn btn-no-border",
							click	: function () {
								Utils.relocate(data.result.redirectUrl);
							}
						});

					} else {
						var message = Loc.g('Vous allez être redirigé dans quelques secondes');

						options.buttons.push({
							text: Loc.g("Voir le devis"),
							click: function () {
								window.location.href = data.result.redirectUrl;
							}
						});

						setTimeout(function() {
							window.location.href = data.result.redirectUrl;
						}, 1500);

					}

					MyWindow.alert(message, options);

				}
			
		}, dataType:"json"};

		var data = {action: 'recordBuilder'};
		
		MyForm.prepare(formId, "planbuilder&"+$.param(data), options, true);
	
		// register builder dom elmt
		self.builder = $("#"+formId);
		self.rqtype = self.builder.find('.rqtype').val();
		self.nbMonthsLeft = self.builder.find('.nbMonthsLeft').val();

		// init builder plan choose
		self.initChoosePlan();
		self.initPriceWatcher();
		
		if (self.rqtype == "upsell"){
			self.plan = self.builder.find('.currentplan').val();
			self.builder.find('#plan_'+self.plan).trigger('click');
		}
		
	},
	
	self.initChoosePlan = function(){
		
		self.builder.find("input[name='plan']").on('click',function(){
			
			var animate = self.plan == null;
			
			// remove selection
			self.builder.find('.plan').removeClass('chosen');
			self.builder.find('.plan-choose label').removeClass('chosen');

			// set new selection
			$(this).closest('.plan').addClass('chosen');
			$(this).closest('.plan-choose').find('label').addClass('chosen');
			
			self.plan = $(this).val();
			self.addonPrice = $(this).closest('.plan-choose').find('.plan_'+self.plan+"_price").val();
			self.planLabel = $(this).closest('.plan-choose').find('.plan_'+self.plan+"_label").val();
			
			self.builder.find('.plan-price').html(self.addonPrice);
			self.builder.find('.plan-label').html(self.planLabel);
			self.builder.find('.plan-chosen').fadeIn(1000);
			
			
			if (animate){
				$('.global').animate({
					scrollTop: parseInt($(".customize-plan").offset().top - 160)
				}, 1000);
			}
			
			self.calculatePrice();
			
		});
		
	};
	
	self.initPriceWatcher = function(){
	
		self.builder.find(".customize-addons input[type='checkbox']").on('click',function(){
			self.calculatePrice();
		});
		
	};

	self.calculatePrice = function(){

		var numFormat = NumberFormat.load();

		var price		= new Big(parseInt(self.addonPrice, 10)).round(2);
		var nbMonths	= new Big(parseFloat(self.nbMonthsLeft, 10));

		var nbNewAddons 	= self.builder.find(".customize-addons input[type='checkbox']:checked:not(:disabled)").length;

		var monthlyPrice	= new Big(0);

		for(var i = 1; i <= (nbNewAddons); i++) {
			monthlyPrice = monthlyPrice.plus(price);
		}

		var yearlyPrice	= monthlyPrice.times(nbMonths);

		yearlyPrice		= NumberFormat.formatToDisplay(yearlyPrice.toFixed(2), numFormat);
		monthlyPrice	= NumberFormat.formatToDisplay(monthlyPrice.toFixed(2), numFormat);

		self.builder.find('.final-price .price-yearly').html(yearlyPrice);
		self.builder.find('.final-price .price-monhtly').html(monthlyPrice);

	};
	
	return self;
	
})(Loc);